import React from "react";
import { ProposalsTable } from "../components/proposal/ProposalsTable";
import {useNavigate, useParams} from "react-router";


export const HomePage: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    return <ProposalsTable createNew={() => navigate("/prop/new")} goBack={() => navigate("/")} idToEdit={id} />
};
